<template>
    <div class="mobile-navigation">
        <nav class="offcanvas-navigation" id="offcanvas-navigation">
            <ul>
                <li><span @click="scrollTo('home')">Start</span></li>
                <li class="menu-item-has-children">
                    <span>Unsere Leistungen</span>
                    <ul class="sub-menu">
                        <li><span @click="scrollTo('faq')">Unser Angebot</span></li>
                        <li><span @click="scrollTo('benefits')">für exklusiv-Kunden</span></li>
                        <li><span @click="scrollTo('merchants')">für Händler</span></li>
                    </ul>
                </li>
                <li><span @click="scrollTo('contact')">Kontakt</span></li>
                <li><a :href="webappUrl" target="_blank">Register-Login</a></li>
            </ul>
        </nav>
    </div>
</template>

<script>
import ScrollTo from './mixins/scrollTo.js'
import { webappUrl } from '@/config.js'

export default {
    name: 'MobileNavMenu',
    mixins: [ScrollTo],
    data() {
        return {
            webappUrl
        }
    },
    mounted() {
        const offCanvasNav = document.querySelector('#offcanvas-navigation');
        const offCanvasNavSubMenu = offCanvasNav.querySelectorAll('.sub-menu');
        const anchorLinks = offCanvasNav.querySelectorAll('a');
    
        for (let i = 0; i < offCanvasNavSubMenu.length; i++){
            offCanvasNavSubMenu[i].insertAdjacentHTML("beforebegin", "<span class='menu-expand'><i></i></span>");
        }
    
        const menuExpand = offCanvasNav.querySelectorAll('.menu-expand');
        const numMenuExpand = menuExpand.length;
    
        for (let i = 0; i < numMenuExpand; i++) {
            menuExpand[i].addEventListener("click", (e) => {sideMenuExpand(e)});
        }
    
        for (let i = 0; i < anchorLinks.length; i++) {
            anchorLinks[i].addEventListener("click", () => {closeMobileMenu()});
        }

        const sideMenuExpand = (e) => {
            e.currentTarget.parentElement.classList.toggle('active');
        }
        const closeMobileMenu = () => {
            const offcanvasMobileMenu = document.querySelector('#offcanvas-mobile-menu');
            if (offcanvasMobileMenu && offcanvasMobileMenu.classList)
                offcanvasMobileMenu.classList.remove('active');
        }
    }
}
</script>

<style lang="scss">
@use '../assets/scss/variabls.scss' as vars;

/* offcanvas mobile menu */
.mobile-navigation {
    padding: 30px 20px;
}
.offcanvas-navigation {
    & > ul {
        li {
            &.menu-item-has-children {
                .sub-menu {
                    height: 0;
                    visibility: hidden;
                    opacity: 0;
                    transition: 0.3s;
                }
                &.active {
                    & > .sub-menu {
                        height: 100%;
                        visibility: visible;
                        opacity: 1;
                    }
                }
            }
            & > span, a {
                color: vars.$white;
                font-weight: 500;
                padding: 10px 0;
                display: block;
                &:hover {
                    color: vars.$white;
                }

            }
        }
    }

    ul {
        &.sub-menu {
            margin-left: 25px;
            transition: 0.3s;
            & > li {
                & > a {
                    font-size: 13px;
                    font-weight: 400;
                    padding: 10px 0;
                    &:hover {
                        color: vars.$white;
                    }
                }
            }
        }
        li {
            a {
                text-transform: uppercase;
            }

            &.menu-item-has-children {
                position: relative;
                display: block;
                a {
                    display: block;
                }

                &.active {
                    & > .menu-expand {
                        i {
                            &:before {
                                transform: rotate(0);
                            }
                        }
                    }
                }

                .menu-expand {
                    position: absolute;
                    right: auto;
                    left: 95%;
                    top: -5px;
                    width: 30px;
                    height: 50px;
                    line-height: 50px;
                    cursor: pointer;
                    text-align: center;

                    i {

                        display: block;
                        margin-top: 27px;
                        border-bottom: 1px solid vars.$white;
                        position: relative;
                        width: 10px;
                        transition: all 250ms ease-out;
                        &:before {
                            width: 100%;
                            content: "";
                            border-bottom: 1px solid vars.$white;
                            display: block;
                            position: absolute;
                            top: 0;
                            transform: rotate(90deg);
                        }
                    }
                }
            }
        }
    }
}
</style>